const Translations = (): any => {
    if (typeof window === 'undefined') {
        return {};
    }

    window.Translations ??= {};

    return window.Translations;
};

export default Translations();
